import { render, staticRenderFns } from "./Hub.vue?vue&type=template&id=0836c11e&"
import script from "./Hub.vue?vue&type=script&lang=js&"
export * from "./Hub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QSpace,QList,QItem,QItemSection,QItemLabel,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QSpace,QList,QItem,QItemSection,QItemLabel,QIcon})
